import { images } from '../assets/images';

export const sidebarMenu = [
  {
    path: "/visual",
    name: "Health Records Map",
    icon: images.upload,
  },
  {
    path: "/symptom",
    name: "Body Diary",
    icon: images.share,
  },
  {
    path: "/dashboard",
    name: "Body Insights",
    icon: images.overview,
  },
  {
    path: "/pricing",
    name: "Pricing plans",
    icon: images.share,
  },
  {
    path: "/visual-nhsi",
    name: "Bulk upload health docs",
    icon: images.share,
  },
];

export const sideBottomMenu = [
  // {
  //     path: '',
  //     name: 'Settings',
  //     icon: images.setting,
  // },
  {
    path: '',
    name: 'Logout',
    icon: images.logout,
  }
];